import type { Method } from 'lib/axios';
import { APICallV4 } from 'reactApp/api/APICall';

export class GetFamilyAlbumListAPICall extends APICallV4 {
    _method = 'family/album/list';
    _type: Method = 'get';
    _retriesCount = 0;
}
